const currencySelector = state => state.currency;
export default currencySelector;
